import { defineComponent as a, openBlock as r, createBlock as l, unref as p, mergeProps as c, withCtx as d, createElementVNode as t } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const v = /* @__PURE__ */ a({
  name: "IconTablet",
  __name: "IconTablet",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (m, e) => (r(), l(p(i), c(n, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        t("path", { d: "M12 19a1 1 0 1 0 0-2 1 1 0 0 0 0 2" }, null, -1),
        t("path", {
          "fill-rule": "evenodd",
          d: "M3.25 5.5A3.25 3.25 0 0 1 6.5 2.25h11a3.25 3.25 0 0 1 3.25 3.25v13a3.25 3.25 0 0 1-3.25 3.25h-11a3.25 3.25 0 0 1-3.25-3.25v-13M6.5 3.75A1.75 1.75 0 0 0 4.75 5.5v13a1.75 1.75 0 0 0 1.75 1.75h11a1.75 1.75 0 0 0 1.75-1.75v-13a1.75 1.75 0 0 0-1.75-1.75h-11",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  v as default
};
